import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { CourseModel } from '@generativ/much-smarter-models';
import { BehaviorSubject } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { environment } from '../../environments/environment';
import { ErrorHandlerService } from '../core/services/error-handler.service';

@Injectable({
  providedIn: 'root',
})
export class CourseService {

  courses: BehaviorSubject<CourseModel[]> = new BehaviorSubject<CourseModel[]>([]);
  activeCourse: BehaviorSubject<CourseModel> = new BehaviorSubject<CourseModel>(null);

  private coursesUrl = environment.msStudentApiUrl + 'courses/';

  constructor(
    private http: HttpClient,
    private errorHandlerService: ErrorHandlerService
  ) {
  }

  fetchAllCourses() {
    this.http
      .get<CourseModel[]>(this.coursesUrl)
      .pipe(catchError(this.errorHandlerService.handleError))
      .subscribe((data: CourseModel[]) => {
        // Student UI stores/compares country as lowercase (`uk`/`us`); API/DB
        // may return `UK`/`US`. Normalize once so filters and navbar match.
        for (const course of data ?? []) {
          if (course.country) {
            course.country = course.country.toLowerCase();
          }
        }
        this.courses.next(data ?? []);
      });
  }

  setActiveCourse(courseId: number) {
    this.courses.getValue().forEach((course: CourseModel) => {
      if (course.id === courseId) {
        localStorage.setItem('selectedCourse', courseId.toString());
        this.activeCourse.next(course);
      }
    });
  }

  getCurrentCountry(): string {
    if (localStorage.getItem('selectedCountry')) {
      return localStorage.getItem('selectedCountry');
    }
    return null;
  }

  setCurrentCountry(countryId: string) {
    localStorage.setItem('selectedCountry', countryId);
  }
}
